import type {
  TextItem,
  TextMarkedContent,
} from 'pdfjs-dist/types/src/display/api';

export type PageTextContent = (TextItem | TextMarkedContent) & {
  pageNum: number;
  numMatches?: number;
};

export function countTextMatches(
  matchedTexts: PageTextContent[] | undefined,
): number {
  if (!matchedTexts) {
    return 0;
  }
  let offset = 0;
  for (const item of matchedTexts) {
    offset += item?.numMatches ?? 0;
  }
  return offset;
}
